import React, { useEffect, useMemo, useState } from 'react';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Collapse,
} from '@mui/material';
import { trakrefBlue, Grey1 } from '../../color_utils';
import { trakrefFontFamilyBold, trakrefFontFamilySemiBold } from '../../utils';
import { listTextStyle, activeReportIndicatorStyle } from './utils';
import "./PowerBI.css";
import { Input } from '../Common';


const AnalyticReportOptions = ({
    reports,
    setSelectedReport,
    selectedReport,
    breadCrumbs,
    pathLength,
    navigateBack
}) => {
    const [search, setSearch] = useState("");
    const [searchReports, setSearchReports] = useState([]);

    const filteredReports = useMemo(() => {
        if (search) {
            return reports.filter((report) =>
                report.name.toLowerCase().includes(search.toLowerCase())
            );
        }
        return reports;
    }, [search, reports]);
    
    useEffect(() => {
        setSearchReports(filteredReports);
    }, [filteredReports]);

    return (
        <List component="div" disablePadding sx={{ marginTop: '4vh' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', paddingBottom: '4px'}}>
                <Input
                    type="text"
                    placeholder="Search for reports..."
                    value={search}
                    variant="standard"
                    onChange={(e) => setSearch(e.target.value)} 
                />
            </div>
            {searchReports && searchReports.map((report) => (
                <Collapse in={true} timeout="auto" unmountOnExit>
                    {
                        <List component="div" disablePadding dense>
                            <ListItem
                                key={report.name}
                                sx={(selectedReport !== null && report.id === selectedReport.id) ? { ...listTextStyle, ...activeReportIndicatorStyle } : listTextStyle}
                            >
                                <ListItemButton
                                    sx={{ pl: 4 }}
                                    onClick={() => {
                                        setSelectedReport(report);
                                        if (breadCrumbs.length > pathLength) {
                                            breadCrumbs.pop();
                                        }
                                        breadCrumbs.push({ text: report.name, tooltip: report.tooltip });

                                        const lastSection = breadCrumbs[breadCrumbs.length - 2];
                                        if (lastSection && !lastSection.onClick) {
                                            lastSection.onClick = () => {
                                                navigateBack(breadCrumbs.length - 2);
                                            };
                                        }
                                    }}
                                >
                                    <ListItemText
                                        primary={report.name}
                                        primaryTypographyProps={{
                                            ...listTextStyle,
                                            color: selectedReport !== null && selectedReport.id === report.id ? trakrefBlue : Grey1
                                        }}
                                        sx={{
                                            '& .MuiListItemText-primary': { 
                                                fontFamily: selectedReport !== null && selectedReport.id === report.id ? trakrefFontFamilyBold : trakrefFontFamilySemiBold 
                                            }
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    }
                </Collapse>
            ))}
        </List>
    );
};

export default AnalyticReportOptions;
